import { ASYNC_SUCCESS } from '../actions'

const defaultState = null

const contacts = (state = defaultState, { type, payload }) => {
  // let stateCopy = { ...state }

  switch (type) {
    case ASYNC_SUCCESS:
      // console.log(payload.actionName)
      switch (payload.actionName) {
        case 'fetchContacts': {
          return {
            ...payload.contacts
          }
        }

        case 'addContactLog': {
          const { contactLog, updatedContactFields } = payload

          return {
            // update some Contact fields (status, lastCallAt)
            ...state,
            [contactLog.contactId]: {
              ...state[contactLog.contactId],
              ...updatedContactFields
            }
          }
        }

        case 'editContact': {
          const { contactId, fields } = payload

          return {
            ...state,
            [contactId]: {
              ...state[contactId],
              ...fields
            }
          }
        }

        case 'createContact': {
          return {
            ...state,
            ...payload.contact
          }
        }

        case 'importContacts': {
          return {
            ...state,
            ...payload.newContacts
          }
        }

        default:
          return state
      }
    // case FETCH_CONTACT_LOGS:
    // // this would cause infinite loop in ContactModal,
    // // so we will store the Contact logs in separate reducer, 'contactLogs'

    default:
      return state
  }
}

export default contacts



// WEBPACK FOOTER //
// ./src/reducers/contacts.js